import React from 'react'
import { Alert, Button, Space } from 'antd'
import { ThunderboltOutlined } from '@ant-design/icons'
import { Link, useLocation } from 'react-router-dom'

import IntlMessages from '../../util/IntlMessages'
import { FrontendUrls } from '../../types/urls'
import { openPlanBoostEndingModal } from '../plan-boost-ending-modal/open-event'
import type { IPlanBoostBannerState } from './use-plan-boost-banner'

interface IPlanBoostBannerProps extends IPlanBoostBannerState {
  sidebarCollapsed?: boolean
  className?: string
  // Only where the ending modal is mounted; the mobile layout has none
  showReviewAction?: boolean
}

// The trial-banner classes come from the stylesheet TrialBanner loads; importing the LESS here would break Storybook
const PlanBoostBanner = ({ daysLeft, isEndingSoon, sidebarCollapsed = false, className = '', showReviewAction = false }: IPlanBoostBannerProps): React.ReactElement => {
  const { pathname } = useLocation()
  // On Billing the link would lead back to the page it sits on
  const onBillingPage = pathname.startsWith(FrontendUrls.billing)

  return (
    <div className={`trial-banner ${sidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'} ${className}`}>
      <Alert
        type={isEndingSoon ? 'warning' : 'info'}
        showIcon
        icon={<ThunderboltOutlined />}
        message={<IntlMessages id="completeBoost.bannerMessage" values={{ days: daysLeft }} />}
        action={
          <Space>
            {showReviewAction && isEndingSoon && (
              <Button size="small" onClick={openPlanBoostEndingModal}>
                <IntlMessages id="completeBoost.reviewChanges" />
              </Button>
            )}
            {onBillingPage ? (
              <IntlMessages id="completeBoost.upgradeOnBillingPage" />
            ) : (
              <Link to={FrontendUrls.billing} className="trial-banner-action">
                <IntlMessages id="completeBoost.upgradeToComplete" />
              </Link>
            )}
          </Space>
        }
        closable={false}
        className="trial-banner-alert"
        role="banner"
        aria-live="polite"
      />
    </div>
  )
}

export default React.memo(PlanBoostBanner)
